import axios from 'axios'
import { EmailTemplate } from './dtos/EmailTemplate.schema'

export const getMailTemplates = async (): Promise<EmailTemplate[]> => {
  const res = await axios.get<EmailTemplate[]>('/mail-templates')
  return res.data
}

export const updateMailTemplate = async (
  uuid: string,
  content: string
): Promise<void> => {
  const res = await axios.put<void>(
    `/mail-templates/${uuid}`,
    { content: content }
  )
}
